import type { Feature, FeatureCollection, Point } from 'geojson';
import type * as MapGL from 'react-map-gl/mapbox';
import { proxy } from 'valtio';
import { getEnvironmentalStudyData } from '~/api/projects2';

class Store {
  environmentalStudyData: FeatureCollection | null = null;
  clickedCoordinates: { lat: number; lng: number } | null = null;
  selectedObjectId: string | null = null;
  selectedFeatures: Feature<Point>[] = [];
  popupLocation: [number, number] | null = null;
  isLoading: boolean = false;
  hasErisData: boolean = true;
  error: string | null = null;

  async fetchEnvironmentalStudyData(projectId: string) {
    this.isLoading = true;
    this.error = null;

    try {
      const envData = await getEnvironmentalStudyData(projectId);

      if (envData?.features && envData.features.length > 0) {
        this.environmentalStudyData = envData;
        this.hasErisData = true;
      } else {
        this.environmentalStudyData = null;
        this.hasErisData = false;
      }
    } catch (error) {
      console.error('Error fetching environmental study data:', error);
      this.environmentalStudyData = null;
      this.hasErisData = false;
      this.error = 'Failed to load environmental study data';
    } finally {
      this.isLoading = false;
    }
  }

  setClickedCoordinates(coordinates: { lat: number; lng: number }) {
    this.clickedCoordinates = coordinates;
  }

  setSelectedFeatures(features: Feature<Point>[]) {
    this.selectedFeatures = features;
  }

  setPopupLocation(location: [number, number] | null) {
    this.popupLocation = location;
  }

  map?: MapGL.MapRef = undefined;

  setCurrentMap(map?: MapGL.MapRef) {
    this.map = map;
  }

  resetCurrentMap() {
    this.map = undefined;
  }
  setSelectedObjectId(objectId: string) {
    this.selectedObjectId = objectId;
  }

  reset() {
    this.environmentalStudyData = null;
    this.clickedCoordinates = null;
    this.selectedObjectId = null;
    this.selectedFeatures = [];
    this.popupLocation = null;
    this.isLoading = false;
    this.hasErisData = true;
    this.error = null;
  }
}

const store = proxy(new Store());

export default store;
